module.exports = __webpack_public_path__ + "images/icons_v2/charge-outlined-0de80c87.svg";